<template>
	<div style="width: 100%">
		<h1>Scraping</h1>
		<b-form inline>
			<b-input-group prepend="Nom">
				<b-form-input v-model="name"></b-form-input>
			</b-input-group>
			<b-input-group prepend="Version">
				<b-form-input v-model="version"></b-form-input>
			</b-input-group>
			<b-button v-b-modal="'modal' + id">Charger</b-button>
			<b-button @click="save_db" :disabled="!version || !name"
				><i class="fas fa-save"></i
			></b-button>
			<b-button v-b-modal="'modal_file' + id">Fichier</b-button>
			<b-button v-b-modal="'modal_rename' + id">Renommer</b-button>
		</b-form>

		<b-modal :hide-footer="true" :id="'modal' + id" title="Charger">
			<span>Nom</span>
			<v-select v-model="load_name" :options="names"></v-select>
			<span>Version</span>
			<v-select
				v-model="load_version"
				:options="versions"></v-select>
		</b-modal>

		<b-modal :hide-footer="true" :id="'modal_file' + id" title="Fichier">
			<b-file
				accept=".json"
				@change="load_file"
				placeholder="charger (fichier)"></b-file>
			<br /><br />
			<b-button @click="save">sauvergarder (fichier)</b-button>
		</b-modal>

		<b-modal :hide-footer="true" :id="'modal_rename' + id" title="Renommer">
			<p>Nouveau nom</p>
			<b-input v-model="new_name"></b-input>
			<br />
			<b-button @click="rename">Rennomer</b-button>
		</b-modal>

		<div>
			<b-dropdown
				:variant="pages.length == 0 ? 'success' : 'secondary'"
				split
				text="+"
				class="m-2"
				@click.prevent="addPage()"
				href="#">
				<b-dropdown-item
					v-for="(template, key) in template_list"
					@click.prevent="addPage(template)"
					v-bind:key="key"
					href="#">
					{{ template }}
				</b-dropdown-item>
			</b-dropdown>

			<b-button @click.prevent="removePage" href="#">-</b-button>&nbsp;
			<b-button @click="tab = 'scraping'">Scraping</b-button>&nbsp;
			<b-button @click="tab = 'scenario'">Scénario</b-button>
		</div>

		<b-tabs v-show="tab == 'scraping'" v-model="index" content-class="mt-3">
			<b-tab
				:title="'Niveau ' + page.lvl"
				v-for="(page, key) in pages"
				:key="key">
				<scraping_page
					:ref="page.lvl"
					:lvl="page.lvl"
					@update_mapping="update_mapping"
					@update_xpath="update_xpath"
					@update_data="update_data"></scraping_page>
			</b-tab>
		</b-tabs>

		<div v-show="tab == 'scenario'">
			<br />
			<project
				ref="scenario"
				initial_method_prop="fichiers"
				:config="false"
				state_prop="etape"></project>
		</div>
	</div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";

	var clone = require("clone");

	import store from "../store";
	import scraping_page from "../components/scraping_page.vue";
	import project from "./Project.vue";
	import element from "../services/element.js";
	import utils from "../services/utils.js";

	export default {
		name: "scraping",
		components: {
			scraping_page,
			project,
		},
		data() {
			return {
				type: "",
				name: "",
				new_name: name,
				names: [],
				versions: [],
				version: "",
				load_name: "",
				load_version: "",
				pages: [],
				index: 0,
				id: uniqueId(),
				tab: "scraping",
				template_list: [],
			};
		},
		watch: {
			index: {
				async handler() {},
			},
			type: {
				async handler() {
					this.set_name();
				},
			},
			load_name: {
				async handler() {
					var elements = await element.getby_libelle(
						this.load_name,
						this.type
					);
					elements = elements.element;

					this.versions = [];
					for (var i = 0; i < elements.length; i++) {
						if (i == 0) {
							if (
								this.load_version &&
								this.load_version == elements[i].version
							)
								await this.load_db();
							this.load_version = elements[i].version;
						}
						this.versions.push(elements[i].version);
					}
				},
			},
			load_version: {
				async handler() {
					if (this.load_version) await this.load_db();
				},
			},
		},
		methods: {
			async rename() {
				console.log("rename");
				await element.rename(this.type, this.name, this.new_name);
				this.name = this.new_name;
				this.save_db();
			},
			async set_name() {
				var names = await element.getby_production(this.type);
				names = names.element;

				this.names = [];
				for (var i = 0; i < names.length; i++) {
					this.names.push(names[i].libelle);
				}
			},
			async save_db() {
				var data = {
					name: this.name,
					pages: [],
				};
				for (var i = 0; i < this.pages.length; i++) {
					var page = await this.$refs[i + 1][0].save();
					data.pages.push(page);
				}
				this.$refs.scenario.update_name(this.name);
				this.$refs.scenario.set_version(this.version);
				//data.scenario = await this.$refs.scenario.save(false);
				await this.$refs.scenario.save_db(false, false);

				await element.save(this.name, this.version, data, this.type);
				await this.set_name();
			},
			async save() {
				var data = {
					name: this.name,
					pages: [],
				};
				for (var i = 0; i < this.pages.length; i++) {
					var page = await this.$refs[i + 1][0].save();
					data.pages.push(page);
				}
				this.$refs.scenario.update_name(this.name);
				this.$refs.scenario.update_version(this.version);
				data.scenario = await this.$refs.scenario.save(false);

				utils.saveToFile(
					JSON.stringify(data),
					(this.name ? this.name : "scraping") + ".json"
				);
			},
			async load(data) {
				var self = this;

				this.pages = [];

				this.name = data.name;
				for (var i = 0; i < data.pages.length; i++) {
					this.pages.push({
						lvl: i + 1,
						data: [],
					});
				}

				self.$nextTick(async function () {
					for (var i = 0; i < data.pages.length; i++) {
						await self.$refs[i + 1][0].load(data.pages[i]);
					}
					if (data.scenario)
						await self.$refs.scenario.load(data.scenario);
					else
						await self.$refs.scenario.load_db(
							self.name,
							self.version
						);
				});
			},
			async load_db() {
				document.body.style.cursor = "wait";
				var result = await element.load(
					this.load_name,
					this.load_version,
					this.type
				);
				this.name = this.load_name;
				this.version = this.load_version;
				await this.load(result);
				document.body.style.cursor = "default";
			},
			async load_file(event) {
				var self = this;

				var file = "";
				if (event.dataTransfer) file = event.dataTransfer.files[0];
				else file = event.target.files[0];

				var reader = new FileReader();

				reader.onload = (function (theFile) {
					return function (e) {
						var data = JSON.parse(e.target.result);
						self.load(data);
					};
				})(file);

				reader.readAsText(file);
			},
			removePage() {
				var lvl = this.pages.length;
				this.pages.splice(this.pages.length - 1, 1);
				this.$refs.scenario.removeStepDescription("Scraping " + lvl);
				this.$refs.scenario.removeStepDescription("Mapping " + lvl);
			},
			async addPage(template) {
				var self = this;

				console.log(template);

				this.pages.push({
					lvl: this.pages.length + 1,
					data: [],
				});

				await this.$refs.scenario.addStep({
					data: {
						action: "scraping",
						label: "Scrapping",
						parameters: {
							params: {
								actions: [],
							},
						},
						sql_rules: "",
					},
					description: "Scraping " + this.pages.length,
					action: "scraping",
					c_conditions: false,
					c_tree: false,
					c_project: false,
					project_id: "",
					c_parameters: true,
					c_tabulator: false,
					c_test: true,
					tabulator2: [],
					keep_start_data: false,
					option_delete: false,
					option_make_list: false,
					treatment: false,
				});

				await this.$refs.scenario.addStep({
					data: {
						action: "fonction",
						label: "Script personnalisé",
						parameters: {
							type: "line",
							code: "",
						},
						sql_rules: "",
					},
					description: "Mapping " + this.pages.length,
					action: "fonction",
					c_conditions: true,
					c_tree: false,
					c_project: false,
					project_id: "",
					c_parameters: true,
					c_tabulator: false,
					c_test: true,
					tabulator2: [],
					keep_start_data: false,
					option_delete: false,
					option_make_list: false,
					treatment: false,
				});

				self.$nextTick(async function () {
					if (template) {
						var result = await element.load(
							template,
							"1",
							"scraping_page_template"
						);
						console.log(result);
						await self.$refs[self.pages.length][0].load({
							result: result.mapping,
							parameters: result.parameters,
							balises: result.balises,
						});
					}

					if (
						self.pages.length > 1 &&
						self.pages[self.pages.length - 2].data.length != 0
					) {
						await self.$refs[self.pages.length][0].set_url(
							self.pages[self.pages.length - 2].data[0]
						);
					}

					self.index = self.pages.length - 1;
				});
			},
			update_data(lvl, data) {
				this.pages[lvl - 1].data = data;
				if (this.pages.length > lvl && data.length > 0) {
					console.log(lvl);
					this.$refs[lvl + 1][0].update_from_prev_level(data[0]);
				}
			},
			update_xpath(lvl, data) {
				this.$refs.scenario.updateStepParametersByDescription(
					"Scraping " + lvl,
					data
				);
			},
			update_mapping(lvl, code) {
				this.$refs.scenario.updateStepParametersByDescription(
					"Mapping " + lvl,
					{
						type: "file",
						code: code,
					}
				);
			},
		},
		mounted: async function () {
			if (store.state.user.rules && !store.state.user.rules.scraping) {
				this.$router.push({ name: "profile" });
			}

			var self = this;

			this.type = "scenario";

			var template_list = await element.getby_production(
				"scraping_page_template"
			);
			this.template_list = [];
			template_list = template_list.element;

			for (var i = 0; i < template_list.length; i++) {
				this.template_list.push(template_list[i].libelle);
			}

			//this.addPage();
		},
	};
</script>

<style scoped>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
		margin-top: 30px;
	}
</style>
